import React, { useContext } from 'react';
import { DistanceContext } from '../distanceContext';
import { Marker, GeoJSON } from 'react-leaflet';

const GeoLayer = () => {
  const { geo, onClick } = useContext(DistanceContext);

  const eachFeature = (id, layer) => {
    layer.on({
      click: (e) => {
        const name = e.target.feature.properties.name;
        onClick(id, name);
      },
    });
  };

  const Layers = () => {
    return geo.map((item, index) => {
      return (
        <div key={index}>
          <GeoJSON
            data={item}
            onEachFeature={(_, layer) => eachFeature(item.id, layer)}
            style={{
              color: 'white',
              fillOpacity: 0.6,
              fillColor: item.properties.color || '#9FC4B4',
              weight: 1,
            }}
          />
          {item.properties.label && (
            <Marker
              key={`m-${index}`}
              position={[item.properties.label.lat, item.properties.label.lng]}
              icon={item.properties.icon}
            />
          )}
        </div>
      );
    });
  };

  return <Layers />;
};

export default GeoLayer;
